import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SignaturePad } from "@/components/SignaturePad";
import { toast } from "sonner";
import { PenLine } from "lucide-react";

export const TechSignature = ({ user, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);
  const [sig, setSig] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get("/auth/me/signature").then((r) => setCurrent(r.data.signature)).catch(() => {}); }, [open]);
  const save = async () => {
    setBusy(true);
    try { await api.put("/auth/me/signature", { signature: sig }); toast.success("Podpis uložen – bude v každém dalším protokolu"); setOpen(false); onChanged?.(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="ghost" className={`hover:bg-white/10 ${user?.has_signature ? "text-slate-200" : "text-amber-300"}`} onClick={() => setOpen(true)} title="Můj podpis" data-testid="tech-signature-open">
        <PenLine className="h-4 w-4" /><span className="hidden sm:inline ml-1 text-xs">{user?.has_signature ? "Můj podpis" : "Nastavit podpis"}</span>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="tech-signature-dialog">
          <DialogHeader><DialogTitle>Můj podpis technika</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Podepište se jednou – podpis se automaticky vloží do každého protokolu, který uložíte.</p>
          {current && <div className="border rounded-lg p-2 bg-slate-50"><div className="text-xs text-slate-500 mb-1">Aktuální podpis</div><img src={current} alt="podpis" className="h-16" data-testid="tech-signature-current" /></div>}
          <SignaturePad onChange={setSig} testId="tech-signature" />
          <div className="flex gap-2 justify-end">
            <Button variant="ghost" onClick={() => setOpen(false)}>Zavřít</Button>
            <Button onClick={save} disabled={busy || !sig} style={{ background: "#0A2540" }} data-testid="tech-signature-save">Uložit podpis</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
